<template>
  <header :class="fixed ? 'fixed' : null">
    <div class="header-group header-group-left">
      <button class="menu-button" @click="openMenuAction()">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="29.9639587px"
          height="19.9589844px"
          viewBox="0 0 29.9639587 19.9589844"
          style="
            enable-background: new 0 0 29.9639587 19.9589844;
            enable-background: new 0 0 29.9639587 19.9589844;
          "
          xml:space="preserve"
          class="menu-icon"
        >
          <g>
            <rect width="29.9639587" height="2.9716384"></rect>
            <rect y="8.7377119" width="29.9639587" height="2.9716384"></rect>
            <rect y="16.9873466" width="29.9639587" height="2.9716384"></rect>
          </g>
        </svg>
      </button>
    </div>

    <div class="header-group header-group-center">
      <img
        src="https://2020-uki.s3.eu-west-2.amazonaws.com/PA_Onboarding/logos/GettyImages_Black.svg"
        class="getty-logo"
      />
    </div>

    <div class="header-group header-group-right">
      <LanguageSelect
        :options="[
          { name: 'English (En)', routerlink: '/', language: 'En' },
          { name: 'Français (Fr)', routerlink: '/fr', language: 'Fr' },
          { name: '日本語 (Jp)', routerlink: '/jp', language: 'Jp' },
        ]"
      />
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LanguageSelect from "./LanguageSelect.vue";

export default {
  components: { LanguageSelect },
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    ...mapGetters(["getIsNavOpen"]),
  },
  methods: {
    ...mapActions(["openMenuAction"]),
  },
};
</script>

<style scoped>
header {
  height: var(--header-height);
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #fff;
  display: flex;
  padding: 16px 40px;
}
header.fixed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
.header-group {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.header-group-left {
  justify-content: flex-start;
}

.header-group-right {
  justify-content: flex-end;
}

.menu-button {
  background: none;
  border: 0;
  padding: 0;
}
.menu-button:hover {
  cursor: pointer;
  color: var(--primary-color);
}

.getty-logo {
  height: 25px;
}
.button {
  border: 1px solid var(--getty-grey-3);
}

@media (max-width: 734px) {
  header {
    padding: 16px;
  }
  .getty-logo {
    height: 20px;
  }
}
</style>